import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingSCN, GetPendingSRA } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import ScnDetails from './ScnDetails';
import TableRow from './TableRow'
import RejectAction from './RejectAction';
import { configuration } from '../Utils/config';
import Pagination from './Pagination';
import SearchComponent from './SearchComponent';

export default function ScnTechApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [OpenModal, setOpenModal] = useState(false);
    const [SingleData, setSingleData] = useState([]);

    const [SearchText, setSearchText] = useState("");

    //get current post

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }


    const AllSRA = async () => {
        let result = await GetPendingSCN()

        console.log("object pending scn", result);

        if (result.status == true) {
            setData(result.queryresult.scndetails)

        }
    }

    const ReadMore = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })
        setOpenModal(true)
        setSingleData(singleInfo)
    }

    const openApprove = (id) => {
        onOpen()
        setId(id)
    }

    useEffect(() => {

        AllSRA()

    }, [isOpen]);


    return (
        <Box>
            <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"ProductName, returnee Dept."} />

            <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

                <Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>

                <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Product name</Th>
                                <Th color="#fff">Price</Th>
                                <Th color="#fff">Qty Returned</Th>
                                <Th color="#fff">Returnee Dept</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">Rejection</Th>
                                <Th color="#fff">Read more</Th>


                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                SearchText === "" ? (
                                    currentData?.map((item, i) => (
                                        <TableRow
                                            key={i}
                                            sn={i + 1}
                                            type="scnApprovalT"
                                            productName={item.shelfid?.productname}
                                            price={item.price}
                                            qty={item.qtyreturned}
                                            dept={item.returneedepartment}
                                            status={item.status}
                                            onClick={() => ReadMore(item._id)}
                                            Approve={() => openApprove(item._id)}

                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && currentData.filter(item => item.shelfid?.productname?.toLowerCase().includes(SearchText) || item.returneedepartment?.toLowerCase().includes(SearchText)).length > 0 ? (

                                        currentData.filter(item => item.shelfid?.productname?.toLowerCase().includes(SearchText) || item.returneedepartment?.toLowerCase().includes(SearchText)).
                                        map((item, i) => (
                                            <TableRow
                                                key={i}
                                                sn={i + 1}
                                                type="scnApprovalT"
                                                productName={item.shelfid?.productname}
                                                price={item.price}
                                                qty={item.qtyreturned}
                                                dept={item.returneedepartment}
                                                status={item.status}
                                                onClick={() => ReadMore(item._id)}
                                                Approve={() => openApprove(item._id)}

                                            />
                                        ))
                                    ) : (
                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                                    )


                                )

                            }


                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />
                <ScnDetails isOpen={OpenModal} onClose={() => setOpenModal(!OpenModal)} singleData={SingleData} />
                {/* this is for the approval modal that receive the type of approval*/}
                <RejectAction isOpen={isOpen} onClose={onClose} id={Id} state="ApproveScn" />


            </Box>
        </Box>
    )
}
